module.exports = __webpack_public_path__ + "static/media/dots.63eae674.svg";